import styled from "styled-components";

export const ContainerSelect = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`;

export const ContainerEntry = styled.div``;

export const ContainerInput = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const Input = styled.input`
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(66, 82, 110, 0.25);
  box-sizing: border-box;
  box-shadow: inset 0px 1px 3px #dddddd;
  border-radius: 24px;
  padding: 10px 20px;

  font-family: "Roboto";
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #5f4a87;

  ::placeholder {
    color: #5f4a87;
  }

  :disabled {
    background: rgba(0, 0, 0, 0.05);
    border: 1px solid #dad8df;
    box-sizing: border-box;
    box-shadow: inset 0px 1px 3px #dddddd;
  }
`;

export const ContainerOptions = styled.div`
  position: absolute;
  top: 41px;
  left: 0px;
  z-index: 10;
  width: 100%;

  display: ${({ isShow }) => (isShow ? "block" : "none")};
`;

export const EmptyOptionMessage = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 7px 15px;
  background: #ffffff;
  color: #5f4a87;
`;

export const Options = styled.div`
  background: #ffffff;
  border: 1px solid #c5b8de;
  box-sizing: border-box;
  box-shadow: 0px 1px 3px #dddddd;
  border-radius: 5px;

  width: 100%;
  height: 100%;
  overflow-y: auto;

  ${({ isCreatable }) =>
    isCreatable ? `padding: 7px 15px 48px 15px` : `padding: 7px 15px`};

  ${({ minMenuHeight, isCreatable }) =>
    minMenuHeight && isCreatable
      ? `min-height: ${minMenuHeight + 41}px`
      : `min-height: ${minMenuHeight}px`};

  ${({ maxMenuHeight, isCreatable }) =>
    maxMenuHeight && isCreatable
      ? `max-height: ${maxMenuHeight + 41}px`
      : `max-height: ${maxMenuHeight}px`};

  :hover::-webkit-scrollbar {
    display: flex;
  }

  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background-color: #efedf3;
  }
`;

export const ContainerCreate = styled.div`
  position: absolute;
  bottom: 0px;
  background: #ffffff;
  border: 1px solid #c5b8de;
  box-sizing: border-box;
  border-radius: 0px 0px 5px 5px;

  padding: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  i {
    color: #5f4a87;
  }
`;

export const CreateText = styled.div`
  color: #5f4a87;
  margin-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ContainerOptionsSelected = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 7px;

  ${({ typeList }) => typeList && `flex-direction: ${typeList}`};
`;

export const ContainerStatus = styled.div`
  position: absolute;
  right: 15px;
  z-index: 1;
  top: 12px;
`;
